
<div class="swiper">
  <div class="swiper-wrapper">

    <div class="swiper-slide likes"> 
      <app-new-likes-icon ></app-new-likes-icon>
    </div>

    <ng-container *ngFor="let aSoul of matchService.souls">
      <div class="swiper-slide profile" *ngIf="!aSoul.lastMessage" (click)="chat(aSoul)">
        <img [src]="aSoul.firstPic" class="profile-picture" (error)="onImageError($event)">
      </div>
    </ng-container>
</div>